import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const EvovaIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 20 20"
    >
      <path
        d="M17.2518 2.74817L16.3201 3.67985C16.4918 3.85152 16.6201 4.0682 16.6851 4.31153L18.6352 11.5867C18.7002 11.8283 18.6968 12.08 18.6352 12.315L19.9069 12.655C20.0285 12.2 20.0335 11.715 19.9069 11.245L17.9568 3.96986C17.8302 3.49985 17.5835 3.08151 17.2518 2.74817Z"
        fill={color}
      />
      <path
        d="M7.34495 0.0931363L7.68495 1.36483C7.91996 1.30149 8.17163 1.29983 8.4133 1.36483L15.6884 3.31487C15.9301 3.37987 16.1468 3.5082 16.3201 3.67987L17.2518 2.74819C16.9185 2.41485 16.5001 2.16818 16.0301 2.04317L8.75664 0.0931363C8.28663 -0.0335329 7.79996 -0.0285328 7.34661 0.0931363H7.34495Z"
        fill={color}
      />
      <path
        d="M0.0931358 7.34495L1.36483 7.68496C1.42816 7.44995 1.5515 7.22995 1.72817 7.05328L7.05327 1.72817C7.22994 1.5515 7.44995 1.4265 7.68495 1.36483L7.34495 0.0931396C6.88994 0.214809 6.46826 0.454813 6.12326 0.798154L0.79815 6.12326C0.453143 6.46827 0.214805 6.88994 0.0931358 7.34495Z"
        fill={color}
      />
      <path
        d="M2.74819 17.2518L3.67987 16.3201C3.5082 16.1485 3.37987 15.9318 3.31487 15.6885L1.36483 8.41333C1.29983 8.17165 1.30316 7.91998 1.36483 7.68498L0.0931363 7.34497C-0.0285328 7.79998 -0.0335329 8.28499 0.0931363 8.755L2.04317 16.0301C2.16984 16.5002 2.41652 16.9185 2.74819 17.2518Z"
        fill={color}
      />
      <path
        d="M12.6551 19.9068L12.315 18.6351C12.08 18.6984 11.8284 18.7001 11.5867 18.6351L4.31155 16.6851C4.06988 16.6201 3.85321 16.4917 3.67987 16.3201L2.74819 17.2518C3.08153 17.5851 3.49987 17.8318 3.96988 17.9568L11.245 19.9068C11.715 20.0335 12.2017 20.0285 12.6551 19.9068Z"
        fill={color}
      />
      <path
        d="M19.9069 12.6551L18.6352 12.3151C18.5718 12.5501 18.4485 12.7701 18.2718 12.9467L12.9467 18.2718C12.7701 18.4485 12.5501 18.5735 12.315 18.6352L12.6551 19.9069C13.1101 19.7852 13.5317 19.5452 13.8767 19.2019L19.2019 13.8768C19.5469 13.5318 19.7852 13.1101 19.9069 12.6551Z"
        fill={color}
      />
      <path
        d="M6.46493 9.05332C6.46493 9.05332 7.94329 9.81667 9.06498 10.9367C10.185 12.0567 10.9484 13.5367 10.9484 13.5367C10.9484 13.5367 10.87 11.875 11.28 10.3433C11.69 8.81165 12.5901 7.41162 12.5901 7.41162C12.5901 7.41162 11.19 8.31164 9.65833 8.72165C8.12663 9.13166 6.46493 9.05332 6.46493 9.05332Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

EvovaIcon.displayName = 'EvovaIcon';
